module.exports = __webpack_public_path__ + "img/productos.d9d225b0.png";